import React from "react";
import { useSelector } from "react-redux";
import { staticURLs } from "../../config/urls";
import { ApplicationState } from "../../store";
import {
    isAvastPartner,
    isCommerceBankPartner,
    isCyberIdLockPartner,
    isAVGPartner,
    isAVGTestPartner,
    isTowerFCUPartner,
    isBitdefenderPartner,
} from "../../util/partner";

const CommerceBankLoginOption = () => {
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );

    const bitdefenderUrl = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.externalHostUrl) ||
            ""
    );

    const openCommerceBankCBIAuthURl = () => {
        window.open(staticURLs.CommerceBankCBIAuthURL, "_blank");
    };

    const openSSOAuthURl = () => {
        window.open(staticURLs.SsoUrl, "_self");
    };

    const openCyberIdLockAuthURl = () => {
        window.open(staticURLs.CyberIdLockAuthURL, "_self");
    };

    const openBitdefenderURI = () => {
        window.open(bitdefenderUrl, "_blank");
    };

    if (isCommerceBankPartner(partnerID)) {
        return (
            <React.Fragment>
                <div className="form-row">
                    <button
                        type="button"
                        onClick={openCommerceBankCBIAuthURl}
                        style={{ width: "100%" }}
                        className="btn-green-large btn-default btn-primary btn-min-width"
                    >
                        <span className="btn-text">Sign in with Commerce Bank</span>
                    </button>
                </div>
                <div className="form-row inline row" style={{ textAlign: "center" }}>
                    <div className="hr-sect">OR</div>
                </div>
            </React.Fragment>
        );
    } else if (isAvastPartner(partnerID)) {
        return (
            <React.Fragment>
                <div className="form-row">
                    <div className="ssoMsgDiv">
                        <h4>Have you purchased this subscription?</h4>
                        &nbsp;
                        <span>Sign in with your Avast Account</span>
                    </div>
                    <button type="button" onClick={openSSOAuthURl} style={{ width: "100%" }} className="btn-orange-large btn-default btn-primary btn-min-width">
                        <span className="btn-text">SIGN IN WITH AVAST ACCOUNT</span>
                    </button>
                </div>
                <div className="form-row inline row" style={{ textAlign: "center" }}>
                    <div className="hr-sect">OR</div>
                </div>
            </React.Fragment>
        );
    } else if (isAVGPartner(partnerID) || isAVGTestPartner(partnerID)) {
        return (
            <React.Fragment>
                <div className="form-row">
                    <div className="ssoMsgDiv">
                        <h4>Have you purchased this subscription?</h4>
                        &nbsp;
                        <span>Sign in with your AVG Account</span>
                    </div>
                    <button type="button" onClick={openSSOAuthURl} style={{ width: "100%" }} className="btn-orange-large btn-default btn-primary btn-min-width">
                        <span className="btn-text">SIGN IN WITH AVG ACCOUNT</span>
                    </button>
                </div>
                <div className="form-row inline row" style={{ textAlign: "center" }}>
                    <div className="hr-sect">OR</div>
                </div>
            </React.Fragment>
        );
    } else if (isCyberIdLockPartner(partnerID)) {
        return (
            <React.Fragment>
                <div className="form-row">
                    <button
                        type="button"
                        onClick={openCyberIdLockAuthURl}
                        style={{ width: "100%" }}
                        className="btn-orange-large btn-default btn-primary btn-min-width"
                    >
                        <span className="btn-text">SIGN INTO CYBERIDLOCK</span>
                    </button>
                </div>
                <div className="form-row inline row" style={{ textAlign: "center" }}>
                    <div className="hr-sect">OR</div>
                </div>
            </React.Fragment>
        );
    // } else if (isTowerFCUPartner(partnerID)) {
    //     return (
    //         <React.Fragment>
    //             <div className="form-row">
    //                 <button type="button" onClick={openSSOAuthURl} style={{ width: "100%" }} className="btn-orange-large btn-default btn-primary btn-min-width">
    //                     <span className="btn-text">SIGN IN</span>
    //                 </button>
    //             </div>
    //         </React.Fragment>
    //     ); // unCommented after testing 
    } else if (isBitdefenderPartner(partnerID)) {
        return (
            <React.Fragment>
                <div className="form-row">
                    <div className="ssoMsgDiv">
                        <h4>Have you purchased this subscription?</h4>
                        &nbsp;
                        <span>Sign in with your Bitdefender Account</span>
                    </div>
                    <button type="button" onClick={openBitdefenderURI} style={{ width: "100%" }} className="btn-orange-large btn-default btn-primary btn-min-width">
                        <span className="btn-text">SIGN IN WITH BITDEFENDER ACCOUNT</span>
                    </button>
                </div>
                <div className="form-row inline row" style={{ textAlign: "center" }}>
                    <div className="hr-sect">OR</div>
                </div>
            </React.Fragment>
        );
    }

    return <React.Fragment></React.Fragment>;
};

export default CommerceBankLoginOption;
